import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GrowerBenchmarkReviewStatusFieldsFragment = { __typename?: 'GrowerBenchmarkReview', reviewId: string, status: Types.GrowerBenchmarkReviewStatus, approvedVersionId?: string | null };

export type GrowerBenchmarkUpsertMetricMutationVariables = Types.Exact<{
  input: Types.GrowerBenchmarkMetricUpsertInput;
}>;


export type GrowerBenchmarkUpsertMetricMutation = { __typename?: 'Mutation', growerBenchmarkUpsertMetric: { __typename?: 'GrowerBenchmarkMetricUpsertPayload', metric?: { __typename?: 'GrowerBenchmarkMetric', communityId: string, metricKey: string, label: string, formula: string, inputs: Array<string>, direction: Types.GrowerBenchmarkMetricDirection, unit: string, decimalPlaces: number, groupKey: string, sortOrder: number, version: number, isActive: boolean, updatedAt: Types.TDateISO, bands: Array<{ __typename?: 'GrowerBenchmarkMetricBand', label: string, lowerThreshold?: number | null, upperThreshold?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordKind: Types.RecordKind, recordId?: string | null }> | null } };

export type OpenGrowerBenchmarkReviewForEditMutationVariables = Types.Exact<{
  reviewId: Types.Scalars['String']['input'];
}>;


export type OpenGrowerBenchmarkReviewForEditMutation = { __typename?: 'Mutation', openGrowerBenchmarkReviewForEdit: { __typename?: 'GrowerBenchmarkReviewPayload', review?: { __typename?: 'GrowerBenchmarkReview', reviewId: string, status: Types.GrowerBenchmarkReviewStatus, approvedVersionId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SaveGrowerBenchmarkReviewVersionMutationVariables = Types.Exact<{
  reviewId: Types.Scalars['String']['input'];
  sections: Array<Types.GrowerBenchmarkReviewSectionInput> | Types.GrowerBenchmarkReviewSectionInput;
  changedSectionIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  findingNotes: Array<Types.GrowerBenchmarkReviewFindingNoteInput> | Types.GrowerBenchmarkReviewFindingNoteInput;
}>;


export type SaveGrowerBenchmarkReviewVersionMutation = { __typename?: 'Mutation', saveGrowerBenchmarkReviewVersion: { __typename?: 'GrowerBenchmarkReviewPayload', review?: { __typename?: 'GrowerBenchmarkReview', reviewId: string, status: Types.GrowerBenchmarkReviewStatus, approvedVersionId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RestoreGrowerBenchmarkReviewVersionMutationVariables = Types.Exact<{
  reviewId: Types.Scalars['String']['input'];
  versionId: Types.Scalars['String']['input'];
}>;


export type RestoreGrowerBenchmarkReviewVersionMutation = { __typename?: 'Mutation', restoreGrowerBenchmarkReviewVersion: { __typename?: 'GrowerBenchmarkReviewPayload', review?: { __typename?: 'GrowerBenchmarkReview', reviewId: string, status: Types.GrowerBenchmarkReviewStatus, approvedVersionId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ApproveGrowerBenchmarkReviewMutationVariables = Types.Exact<{
  reviewId: Types.Scalars['String']['input'];
  versionId: Types.Scalars['String']['input'];
  outputType: Types.GrowerBenchmarkReviewOutputType;
}>;


export type ApproveGrowerBenchmarkReviewMutation = { __typename?: 'Mutation', approveGrowerBenchmarkReview: { __typename?: 'GrowerBenchmarkReviewPayload', review?: { __typename?: 'GrowerBenchmarkReview', reviewId: string, status: Types.GrowerBenchmarkReviewStatus, approvedVersionId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReleaseGrowerBenchmarkReviewMutationVariables = Types.Exact<{
  reviewId: Types.Scalars['String']['input'];
}>;


export type ReleaseGrowerBenchmarkReviewMutation = { __typename?: 'Mutation', releaseGrowerBenchmarkReview: { __typename?: 'GrowerBenchmarkReviewPayload', review?: { __typename?: 'GrowerBenchmarkReview', reviewId: string, status: Types.GrowerBenchmarkReviewStatus, approvedVersionId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const GrowerBenchmarkReviewStatusFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkReviewStatusFields on GrowerBenchmarkReview {
  reviewId
  status
  approvedVersionId
}
    `, {"fragmentName":"GrowerBenchmarkReviewStatusFields"});
export const GrowerBenchmarkUpsertMetricDocument = new TypedDocumentString(`
    mutation GrowerBenchmarkUpsertMetric($input: GrowerBenchmarkMetricUpsertInput!) {
  growerBenchmarkUpsertMetric(input: $input) {
    metric {
      ...GrowerBenchmarkMetricFields
    }
    errors {
      code
      message
      recordKind
      recordId
    }
  }
}
    fragment GrowerBenchmarkMetricFields on GrowerBenchmarkMetric {
  communityId
  metricKey
  label
  formula
  inputs
  direction
  unit
  decimalPlaces
  bands {
    ...GrowerBenchmarkMetricBandFields
  }
  groupKey
  sortOrder
  version
  isActive
  updatedAt
}
fragment GrowerBenchmarkMetricBandFields on GrowerBenchmarkMetricBand {
  label
  lowerThreshold
  upperThreshold
}`);
export const OpenGrowerBenchmarkReviewForEditDocument = new TypedDocumentString(`
    mutation OpenGrowerBenchmarkReviewForEdit($reviewId: String!) {
  openGrowerBenchmarkReviewForEdit(reviewId: $reviewId) {
    review {
      ...GrowerBenchmarkReviewStatusFields
    }
    errors {
      code
      message
    }
  }
}
    fragment GrowerBenchmarkReviewStatusFields on GrowerBenchmarkReview {
  reviewId
  status
  approvedVersionId
}`);
export const SaveGrowerBenchmarkReviewVersionDocument = new TypedDocumentString(`
    mutation SaveGrowerBenchmarkReviewVersion($reviewId: String!, $sections: [GrowerBenchmarkReviewSectionInput!]!, $changedSectionIds: [String!]!, $findingNotes: [GrowerBenchmarkReviewFindingNoteInput!]!) {
  saveGrowerBenchmarkReviewVersion(
    reviewId: $reviewId
    sections: $sections
    changedSectionIds: $changedSectionIds
    findingNotes: $findingNotes
  ) {
    review {
      ...GrowerBenchmarkReviewStatusFields
    }
    errors {
      code
      message
    }
  }
}
    fragment GrowerBenchmarkReviewStatusFields on GrowerBenchmarkReview {
  reviewId
  status
  approvedVersionId
}`);
export const RestoreGrowerBenchmarkReviewVersionDocument = new TypedDocumentString(`
    mutation RestoreGrowerBenchmarkReviewVersion($reviewId: String!, $versionId: String!) {
  restoreGrowerBenchmarkReviewVersion(reviewId: $reviewId, versionId: $versionId) {
    review {
      ...GrowerBenchmarkReviewStatusFields
    }
    errors {
      code
      message
    }
  }
}
    fragment GrowerBenchmarkReviewStatusFields on GrowerBenchmarkReview {
  reviewId
  status
  approvedVersionId
}`);
export const ApproveGrowerBenchmarkReviewDocument = new TypedDocumentString(`
    mutation ApproveGrowerBenchmarkReview($reviewId: String!, $versionId: String!, $outputType: GrowerBenchmarkReviewOutputType!) {
  approveGrowerBenchmarkReview(
    reviewId: $reviewId
    versionId: $versionId
    outputType: $outputType
  ) {
    review {
      ...GrowerBenchmarkReviewStatusFields
    }
    errors {
      code
      message
    }
  }
}
    fragment GrowerBenchmarkReviewStatusFields on GrowerBenchmarkReview {
  reviewId
  status
  approvedVersionId
}`);
export const ReleaseGrowerBenchmarkReviewDocument = new TypedDocumentString(`
    mutation ReleaseGrowerBenchmarkReview($reviewId: String!) {
  releaseGrowerBenchmarkReview(reviewId: $reviewId) {
    review {
      ...GrowerBenchmarkReviewStatusFields
    }
    errors {
      code
      message
    }
  }
}
    fragment GrowerBenchmarkReviewStatusFields on GrowerBenchmarkReview {
  reviewId
  status
  approvedVersionId
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GrowerBenchmarkUpsertMetric: build.mutation<GrowerBenchmarkUpsertMetricMutation, GrowerBenchmarkUpsertMetricMutationVariables>({
      query: (variables) => ({ document: GrowerBenchmarkUpsertMetricDocument, variables })
    }),
    OpenGrowerBenchmarkReviewForEdit: build.mutation<OpenGrowerBenchmarkReviewForEditMutation, OpenGrowerBenchmarkReviewForEditMutationVariables>({
      query: (variables) => ({ document: OpenGrowerBenchmarkReviewForEditDocument, variables })
    }),
    SaveGrowerBenchmarkReviewVersion: build.mutation<SaveGrowerBenchmarkReviewVersionMutation, SaveGrowerBenchmarkReviewVersionMutationVariables>({
      query: (variables) => ({ document: SaveGrowerBenchmarkReviewVersionDocument, variables })
    }),
    RestoreGrowerBenchmarkReviewVersion: build.mutation<RestoreGrowerBenchmarkReviewVersionMutation, RestoreGrowerBenchmarkReviewVersionMutationVariables>({
      query: (variables) => ({ document: RestoreGrowerBenchmarkReviewVersionDocument, variables })
    }),
    ApproveGrowerBenchmarkReview: build.mutation<ApproveGrowerBenchmarkReviewMutation, ApproveGrowerBenchmarkReviewMutationVariables>({
      query: (variables) => ({ document: ApproveGrowerBenchmarkReviewDocument, variables })
    }),
    ReleaseGrowerBenchmarkReview: build.mutation<ReleaseGrowerBenchmarkReviewMutation, ReleaseGrowerBenchmarkReviewMutationVariables>({
      query: (variables) => ({ document: ReleaseGrowerBenchmarkReviewDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGrowerBenchmarkUpsertMetricMutation, useOpenGrowerBenchmarkReviewForEditMutation, useSaveGrowerBenchmarkReviewVersionMutation, useRestoreGrowerBenchmarkReviewVersionMutation, useApproveGrowerBenchmarkReviewMutation, useReleaseGrowerBenchmarkReviewMutation } = injectedRtkApi;
